import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {useTranslate} from "../../../system/useTranslate";
import {InputText} from "primereact/inputtext";
import InputLabel from "../../../system/components/input-label";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {useSelector} from "react-redux";
import SelectMember from "../../tasks/components/select-member";
import {MultiSelect} from "primereact/multiselect";
import GoalParentSelect, {MISSION_PARENT} from "./goal-parent-select";
import SelectZofinoDateTime from "../../tasks/components/select-zofino-datetime";
import SelectTaskType from "../../tasks/components/select-task-type";
import {TabPanel, TabView} from "primereact/tabview";
import StrategyMap from "../tabs/strategy-map";
import MyGoals from "../tabs/my-goals";
import TeamGoals from "../tabs/team-goals";
import {useMountEffect, useUpdateEffect} from "primereact/hooks";
import SelectMembers from "../../tasks/components/select-members";
import {OverlayPanel} from "primereact/overlaypanel";
import SelectCycle from "./select-cycle";
import Avatar from "../../../system/components/avatar";
import AvatarGroup from "../../../system/components/avatar-group";
import SelectableTabsButton, {useSelectableTabs} from "../../components/selectable-tabs-button";

function GoalProjectDialog({visible, onSubmit, payload, onHide, singleTab}) {
    const translate = useTranslate();
    const [activeIndex,setActiveIndex] = useState(0);
    const [state, setState] = useState();
    const [parentError, setParentError] = useState(false);

    const availableTabs = [
        { id: "goal", label: "create-goal", icon: "mi mi:flag", view:CreateGoal },
        { id: "project", label: "create-project", icon: "mi mi:person", view:CreateProject }];
    const forcedType = payload?.mode === "create-child" && payload?.from?.node?.type === "project"
        ? "project"
        : singleTab;
    const tabs = forcedType
        ? availableTabs.filter((tab) => tab.id === forcedType)
        : availableTabs;
    const {visibleTabs, selectedIds, toggleTab} = useSelectableTabs(tabs, "visible-tabs:goal-project-dialog", activeIndex, setActiveIndex);

    useEffect(()=>{
        if (visible){
            setActiveIndex(forcedType
                ? 0
                : (payload?.draft?.type === "project" || payload?.from?.node?.type === "project" ? 1 : 0))

            let _state = {mapX:payload?.position?.x, mapY:payload?.position?.y}
            if (forcedType)_state = {...payload, ..._state};
            setState(_state);
            setParentError(false);
        }
    },[visible])

    const submit = ()=>{
        const type = visibleTabs[activeIndex]?.id;
        // parentChoice is UI-only state of the goal tab; it is never a valid API field (also not for projects).
        const {parentChoice, ...cleanState} = state;
        if (type !== "goal") {
            onSubmit?.({state: cleanState, type});
            return;
        }
        if (!parentChoice) cleanState.isOrphan = true;
        onSubmit?.({state: cleanState, type});
    }

    const visibleTab = (tab, payload)=>{
        if (payload?.from?.node?.type === "mission") {
            return tab.id === "goal";
        }

        if (forcedType){
            return tab.id===forcedType
        }
        else {
            if (payload===undefined){
                return true
            }
            if (tab.id=== "project"){
                if(payload?.from?.node?.type==="project"&&payload?.from?.edge==="bottom") return true;
                else if(payload?.from?.node?.type==="project"&&payload?.from?.edge==="top") return true;
                else if(payload?.from?.node?.type==="goal"&&payload?.from?.edge==="bottom") return true;
                else if(payload?.from?.node?.type==="goal"&&payload?.from?.edge==="top") return false;
            }
            if (tab.id=== "goal"){
                if(payload?.from?.node?.type==="project"&&payload?.from?.edge==="bottom") return false;
                else if(payload?.from?.node?.type==="project"&&payload?.from?.edge==="top") return true;
                else if(payload?.from?.node?.type==="goal"&&payload?.from?.edge==="bottom") return true;
                else if(payload?.from?.node?.type==="goal"&&payload?.from?.edge==="top") return true;
            }
        }
    }

    return (
        <Dialog pt={{root:()=>({className:"border-round-2xl"}),footer:()=>({className:"p-0 border-round-bottom-2xl"}),header:()=>({className:"border-round-top-2xl"}),content:()=>({className:"p-0 h-full"})}}  className="rtl w-6" visible={visible} onHide={()=>{onHide?.();}} footer={<Footer onHide={onHide} onSubmit={submit}/>}>

            {/* تب‌ها */}
            <div className="flex-1 min-h-0 flex flex-column relative">
                <SelectableTabsButton tabs={tabs} selectedIds={selectedIds} onChange={toggleTab} className="absolute z-5" style={{top: ".45rem", left: ".75rem"}}/>
                <TabView lazy activeIndex={activeIndex} onTabChange={(e)=>{setActiveIndex(e.index);}}
                         panelContainerClassName="flex-1  min-h-0 p-0 border-noround"
                         className="h-full flex flex-column">
                    {visibleTabs.map((tab, tabIndex) => {
                        const TabContent = tab.view;
                        return (
                        <TabPanel
                            key={tab.id}
                            visible={visibleTab(tab, payload)}
                            header={translate(tab.label)}
                            leftIcon={<Icon icon={tab.icon} className="pl-2" />}
                            className="h-full text-xs">
                            {tabIndex === activeIndex && <div className="h-full min-h-0 overflow-hidden">
                                <TabContent state={state} setState={setState} payload={payload} parentError={parentError} setParentError={setParentError} />
                            </div>}
                        </TabPanel>
                    )})}
                </TabView>
            </div>
        </Dialog>
    );
}

function GoalToolbar({state, setState}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();

    return(
        <div className="flex flex-wrap gap-2 align-items-center">
            <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                <SelectMember label={translate("goal-owner")} selectedMember={state?.owner} onChange={(membership)=>{setState({...state, owner: membership})}} members={workspaceMembershipData?.workspace.workspace_memberships || []} />
            </div>
            <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                <SelectCyclePopup value={state?.cycle} onChange={(e)=>{setState({...state, cycle:e})}} />
            </div>

        </div>
    )
}

function SelectCyclePopup({value, onChange}) {
    const translate = useTranslate()
    const ref  = useRef();
    return(
        <div>
            <Button pt={{label:()=>({className:"font-normal"})}} className="w-full  shadow-none border-none p-2 px-2 text-xs text-600 p-button-secondary border-300 bg-white" label={value?`${translate(value?.range)} ${value?.year}`:translate("select-cycle")} onClick={(e)=>{ref.current.toggle(e)}}/>
            <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                <SelectCycle value={value} onChange={(e)=>{onChange?.(e); }} onHide={()=>{ref.current.hide()}}/>
            </OverlayPanel>
        </div>


        // <Dropdown options={options} value={value} onChange={onChange}/>
    )
}

function ProjectToolbar({state, setState}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();

    return(
        <div className="flex flex-wrap gap-2 align-items-center">
            <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                <SelectMember label={translate("project-owner")} selectedMember={state?.owner} onChange={(membership)=>{setState({...state, owner: membership})}} members={workspaceMembershipData?.workspace.workspace_memberships || []} />
            </div>

        </div>
    )
}

function Footer({onHide, onSubmit}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button icon={<Icon icon="mi mi:save" className="text-lg"/>} className="text-xs flex gap-2 border-round-lg p-2" label={translate("save-changes")} onClick={onSubmit}/>
            <Button className="text-xs p-button-secondary p-button-outlined border-round-lg p-2" label={translate("cancel")} onClick={()=>{onHide?.()}}/>
        </div>
    )
}

function GoalParentField({state, setState, parentError, setParentError}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    return(
        <GoalParentSelect
            value={state?.parentChoice}
            goals={workspaceMembershipData?.workspace?.goals}
            invalid={false}
            onChange={(value)=>{
                const {parentGoal, ...rest} = state || {};
                setState(!value
                    ? {...rest, parentChoice: undefined}
                    : value === MISSION_PARENT
                        ? {...rest, parentChoice: value}
                        : {...rest, parentChoice: value, parentGoal: value});
                setParentError?.(false);
            }}
        />
    )
}

function CreateGoal({state, setState, payload, parentError, setParentError}) {
    const translate = useTranslate();
    useMountEffect(()=>{
        let _state = {...state}
        delete _state.goals;
        delete _state.parentProjects;
        delete _state.childProjects;
        _state.projects = state.childProjects;
        if (payload?.from?.node?.type === "mission") {
            setState({..._state, parentChoice: MISSION_PARENT});
            return;
        }

        if (payload?.from?.node?.type==="goal") {
            if (payload?.from?.edge==="top"){
                _state = {..._state, childrenGoals:[payload?.from?.node?.data?.entity.id], parentChoice: MISSION_PARENT}
            }
            if (payload?.from?.edge==="bottom"){
                _state = {..._state, parentGoal:payload?.from?.node?.data?.entity.id, parentChoice:payload?.from?.node?.data?.entity.id}
            }
        }
        if (payload?.from?.node?.type === "project" && payload?.from?.edge === "top") {
            _state = {
                ..._state,
                projects: [payload?.from?.node?.data?.entity.id],
            };
        }
        // console.log(_state)
        setState(_state);
    })
    return(
        <div className="flex flex-column p-3 gap-3">
            <InputLabel require inputType="TEXT" value={state?.title||""} onChange={(e)=>{setState({...state, title:e.target.value})}} label={translate("goal-title")} placeholder={translate("goal-title-placeholder")} />
            <GoalParentField state={state} setState={setState} parentError={parentError} setParentError={setParentError}/>
            <InputLabel require inputType="RICHTEXT" value={state?.description||""} onChange={(e)=>{setState({...state, description:e.target.value})}} label={translate("goal-description")} placeholder={translate("goal-description-placeholder")} />
            <GoalToolbar state={state} setState={setState}/>
        </div>
    )
}
function CreateProject({state, setState, payload}) {
    const translate = useTranslate();
    const {workspaceMembershipData} = useSelector((state) => state.app);

    useMountEffect(()=>{
        let _state = {...state}
        delete _state.parentGoal;
        if (payload?.from?.node?.type==="goal") {
            _state = {..._state, goals:[payload?.from?.node?.data?.entity.id]}
        }
        if (payload?.from?.node?.type==="project") {
            if (payload?.from?.edge==="top"){
                _state = {..._state, childProjects:[payload?.from?.node?.data?.entity.id]}
            }
            if (payload?.from?.edge==="bottom"){
                _state = {..._state, parentProjects:[payload?.from?.node?.data?.entity.id]}
            }
        }
        setState(_state);
    })

    useUpdateEffect(()=>{
        setState({...state, members:state?.owner?[state.owner]:undefined})

    },[state?.owner])

    return(
        <div className="flex flex-column p-3 gap-3">
            <InputLabel require inputType="TEXT" value={state?.title||""} onChange={(e)=>{setState({...state, title:e.target.value})}} label={translate("project-title")} placeholder={translate("project-title-placeholder")} />
            <InputLabel require inputType="RICHTEXT" value={state?.description} onChange={(e)=>{setState({...state, description:e.target.value})}} label={translate("project-description")} placeholder={translate("project-description-placeholder")} />
            <InputLabel  label={translate("project-owner")}>
                <div className="border-1 border-300 border-round p-1 px-2">
                    <SelectMember label={translate("choose-project-owner")} selectedMember={state?.owner} onChange={(membership)=>{setState({...state, owner: membership})}} members={workspaceMembershipData?.workspace.workspace_memberships || []} />
                </div>
            </InputLabel>
            {/*<ProjectToolbar state={state} setState={setState}/>*/}
            {
                state?.owner&&(
                    <InputLabel label={translate("project-members")}>
                        <ProjectMembers projectData={state} onChange={(e)=>{setState({...state, members:e.members})}}/>
                    </InputLabel>
                )
            }
        </div>
    )
}

function ProjectMembers({projectData, onChange}) {
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [newMembersData, setNewMembersData] = useState();


    useEffect(() => {
        setNewMembersData(projectData?.members);
    }, []);


    useUpdateEffect(()=>{
        if (newMembersData){
            onChange?.({members:newMembersData?.map(m=>({member:m, role:m.role}))});
        }
    },[newMembersData])


    //
    // const modifyMembers = (data)=>{
    //     if (data?.status==="added"){
    //         setNewMembersData([...newMembersData??[], data.member])
    //     }
    //     if (data?.status==="removed"){
    //         setNewMembersData([...newMembersData??[]].filter(m=>m.id!==data.member.id))
    //     }
    // }
    const ItemTemplate = (data)=>{
        return data?(
            <div className="w-fit flex align-items-center gap-1 text-xs">
                <Avatar memberData={data?.member}/>
                {data?.member.fullname}
            </div>
        ):(
            <div className="p-2">{translate("select-members-placeholder")}</div>
        )
    }
    // const SelectedItemTemplate = (data)=>{
    //     return (
    //         <div className="w-fit flex align-items-center gap-1 text-xs p-1 surface-100 border-round-2xl">
    //             <Avatar  memberData={data?.member}/>
    //             {/*{data?.member.fullname}*/}
    //         </div>
    //     )
    // }

    return(
        <div onClick={(e)=>{}} className="border-round border-1 border-300 flex justify-content-between pr-2">
            <AvatarGroup>
                {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
            </AvatarGroup>
            <MultiSelect selectedItemsLabel={`${newMembersData?.length} ${translate("member")}`}  filterTemplate={(options)=>(<InputText placeholder={translate("search-members-placeholder")} onChange={options.filterOptions.filter} className="p-2 w-full text-xs"/>)} filter filterBy="member.fullname" placeholder={translate("select-members-placeholder")} pt={{root:()=>({className:"w-full border-none shadow-none"}),label:()=>({className:"hidden"}) ,labelContainer:()=>({className:"align-items-center flex pr-2"}) ,trigger:()=>({className:"p-3"}) , filterInput:()=>({className:"p-0"}), header:()=>({className:"p-2 flex-row-reverse"}), item:()=>({className:"flex-row-reverse justify-content-between p-2"})}} panelClassName="rtl" onChange={(e)=>{setNewMembersData(e.value)}}  itemTemplate={ItemTemplate} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        </div>
        // <div className="flex flex-column gap-2" >
        //     <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={memberRef}>
        //         <MultiSelectMembers onChange={(e)=>{modifyMembers(e)}} options={workspaceMembershipData?.workspace?.workspace_memberships} value={newMembersData||[]}/>
        //     </OverlayPanel>
        //     <div className="border-round border-1 border-300 p-2 flex justify-content-between">
        //         <AvatarGroup className="ltr">
        //             {newMembersData?.map(m=>(<Avatar memberData={m.member}/>))}
        //         </AvatarGroup>
        //         <Icon icon="pi pi-chevron-down text-sm p-2" className="p-2" onClick={(e)=>{memberRef.current.toggle(e)}} />
        //     </div>
        // </div>
    )
}

export default GoalProjectDialog;
